
import { useEffect } from "react";

export default function LazyRabbitSign(props: any) {

  useEffect(() => {
    GenerateAndSendToSign();
  }, [props.fileDatabaseId]);

  useEffect(() => {
    const wrapper = document.getElementById(`send-document-to-rabbit-sign-root-lazy`);

    if (!wrapper) return;
    const clickHandler = () => {
      props.GenerateAndSendToSign();
    };

    if (props.fileDatabaseId !== "") {
      setTimeout(() => {
        const realButton: any = wrapper.querySelector("svg");
        realButton?.dispatchEvent(new Event("click", { bubbles: true }));
      }, 1000);
    }

    wrapper.addEventListener("click", clickHandler);
    return () => wrapper.removeEventListener("click", clickHandler);
  }, [props.fileDatabaseId]);

  const GenerateAndSendToSign = () => {
    const reactCdnPath = "https://nc-test-cdn.azureedge.net/react-sources-v2-cdn";
    const asCode = "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";

    const ncDomain = "https://newtest.nowcerts.com/";
    const ncReactApiDomain = "https://test-bff-api.nowcerts.com/api";

    window.REACT_APP_DOMAIN = ncDomain;
    window.REACT_APP_THEME = 4;
    window.REACT_ASSETS_ROOT_PATH = reactCdnPath;
    window.REACT_API_ROOT = ncReactApiDomain;
    window.REACT_AUTH_TOKEN = asCode;
    window.REACT_CDN_PATH = reactCdnPath;

    let reactKey = Math.random() * 10000
    localStorage.setItem("x-nc-code", asCode);
    localStorage.setItem("reactTabKey", reactKey.toString());

    const pluginSrc = `${reactCdnPath}/scripts/tinymce/tinymce.min.js`;
    const tinyScript = document.createElement("script");
    tinyScript.src = pluginSrc;
    document.head.appendChild(tinyScript);

    fetch(reactCdnPath + "/asset-manifest.json")
      .then((r) => r.json())
      .then((manifest) => {
        manifest.entrypoints.forEach((file: any) => {
          const url = `${reactCdnPath}/${file}`;
          if (file.endsWith(".js")) {
            const s = document.createElement("script");
            s.src = url;
            document.head.appendChild(s);
          } else if (file.endsWith(".css")) {
            const l = document.createElement("link");
            l.rel = "stylesheet";
            l.href = url;
            document.head.appendChild(l);
          }
        });
      });

    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("NCM_LAZY_LOAD_REACT_RABBIT_SIGN_DOCUMENT_MODAL", {
          detail: {
            selectedFiles: [{ id: props.fileDatabaseId, order: 0 }],
            emails: [
              {
                email: "sourabh@momentumamp.com",
                name: "Sourabh N",
                contactType: 1,
              },
              {
                email: "LISA@ENVELA.COM",
                name: "Lisa",
                contactType: 4,
              }
            ],
            insuredId: "00ff4313-94d7-43dd-9dc7-e2e8abc8fa30",
            embeddedData: {
              fromEmail: "amita@momentumamp.com",
              subject: "Please sign this document",
              body: "Please sign this document",
              insuranceAgencyId: "6c0a66c1-91db-42f0-8040-7bfe9a71d2a5",
            },
            showButtonIcon: true,
            buttonTitle: "Sign Document",
          },
        })
      );
    }, 500);
  }
  return <div id={`send-document-to-rabbit-sign-root-lazy`}></div>;
}
